import { render, staticRenderFns } from "./InTransitWaybill.vue?vue&type=template&id=31668021&scoped=true&"
import script from "./InTransitWaybill.vue?vue&type=script&lang=js&"
export * from "./InTransitWaybill.vue?vue&type=script&lang=js&"
import style0 from "./InTransitWaybill.vue?vue&type=style&index=0&id=31668021&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31668021",
  null
  
)

export default component.exports